function parseJson2Server(json){
  const newJson = {};
  for(let key in json){
    newJson[key] = json[key].value
  }

  return newJson
}

export {parseJson2Server}